import Vue from 'vue'


import XFileButton from './components/x-file-button.vue'
Vue.component(XFileButton.name, XFileButton)

